import { SHOW_FOOTER_CONTINUE } from "../actions/action-types";

export const showFooterContinueReducer = (state = false, action) => {
  if (action.type === SHOW_FOOTER_CONTINUE) {
    return {
      value: action.continueBtn.isShow,
      handle: action.continueBtn.handler,
      disabled: action.continueBtn.disabled
    };
  }
  return state;
};
